(() => {
  if (window.ycInquiryReady) return;
  window.ycInquiryReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href^="mailto:"]');
    if (!link || !/inquir|availability/i.test(link.textContent)) return;
    const email = new URL(link.href);
    const product = (email.searchParams.get('subject') || 'this product').replace(/^(?:Availability inquiry|Inquiry)\s*:\s*/i, '');
    email.searchParams.set('body', `Hello,\n\nI'm inquiring about ${product}. Could you please let me know if it is available?\n\nThank you.`);
    link.href = email.href;
    if (!matchMedia('(min-width:769px)').matches) return;
    const gmail = new URL('https://mail.google.com/mail/');
    gmail.searchParams.set('view','cm');
    gmail.searchParams.set('fs','1');
    gmail.searchParams.set('to',decodeURIComponent(email.pathname));
    for (const [source,target] of [['subject','su'],['body','body'],['cc','cc'],['bcc','bcc']]) {
      const value = email.searchParams.get(source);
      if (value) gmail.searchParams.set(target,value);
    }
    event.preventDefault();
    event.stopPropagation();
    window.open(gmail.href,'_blank','noopener,noreferrer');
  }, true);
})();
